module.exports = __webpack_public_path__ + "static/media/this_or_that_logo.749577c3.svg";